import { JourneyName } from "@/sdk"

const journeyNameCreditMatch = {
    feta: "feta_ignition",
    feta_meeting: "feta_meeting_level_1"
}

export function totalOrUnlimited(total?: number) : string{
    if(total === undefined)
        return '0'

    if(total === -1)
        return '∞'

    return total.toString()
}

export function getCreditName(name: JourneyName){
    if(Object.hasOwn(journeyNameCreditMatch, name))
        return journeyNameCreditMatch[name]
    return name
}